module.exports = __webpack_public_path__ + "assets/img/EducationIndex_3.4ff9348c.png";